import { render, staticRenderFns } from "./Recharge.vue?vue&type=template&id=31f970ea&scoped=true"
import script from "./Recharge.vue?vue&type=script&lang=js"
export * from "./Recharge.vue?vue&type=script&lang=js"
import style0 from "./Recharge.vue?vue&type=style&index=0&id=31f970ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f970ea",
  null
  
)

export default component.exports